import { createContext, type ReactNode, useContext } from 'react';
import { type FlagKey, isOn, type StaffMe } from '@reikraft/shared';

const Ctx = createContext<StaffMe | null>(null);

export function SessionProvider({ me, children }: { me: StaffMe; children: ReactNode }) {
  return <Ctx.Provider value={me}>{children}</Ctx.Provider>;
}

export function useMe(): StaffMe {
  const me = useContext(Ctx);
  if (!me) throw new Error('Нет сессии');
  return me;
}

export function useFlag(key: FlagKey): boolean {
  return isOn(useMe().flags, key);
}

export function useTz(): string {
  return useMe().company.timezone || 'Europe/Moscow';
}
